import NextImage, { type ImageProps } from "next/image";

function joinClassNames(...values: Array<string | undefined>) {
  return values.filter(Boolean).join(" ");
}

export default function ProtectedImage({
  alt,
  className,
  draggable,
  fill,
  unoptimized,
  ...props
}: ImageProps) {
  return (
    <span
      data-protected-image-root
      className={joinClassNames(
        "image-protect-root",
        fill ? "image-protect-fill" : undefined,
      )}
    >
      <NextImage
        {...props}
        alt={alt}
        fill={fill}
        draggable={draggable ?? false}
        unoptimized={unoptimized}
        className={joinClassNames(className, "image-protect-target")}
      />
      <span aria-hidden="true" className="image-protect-overlay" />
    </span>
  );
}
